import * as React from 'react';
import { Link, OutsideClick, Popup, PopupArrow } from '@cian/components';
import { mergeStyles } from '@cian/utils';
import { ProblemIcon } from './ProblemIcon';
import { trackProblemIconHover, trackProblemMoreButtonClick } from '../../../../utils/tracking';
import * as style from './index.css';

export interface IPromoFlagProps {
  url: string;
  GKId: number;
}

export interface IPromoFlagState {
  showPopup: boolean;
}

export class ProblemPopup extends React.Component<IPromoFlagProps, IPromoFlagState> {
  public state = {
    showPopup: false,
  };

  private onProblemIconHover = () => {
    const { GKId } = this.props;
    trackProblemIconHover('problem', GKId);
  };

  private onMoreButtonClick = () => {
    const { GKId } = this.props;
    trackProblemMoreButtonClick('problem', GKId);
  };

  public render() {
    const { showPopup } = this.state;

    return (
      <span onMouseEnter={this.toggle(true)}>
        <OutsideClick onOutsideClick={this.toggle(false)} rootElement={<div className={style['container']} />}>
          <span
            {...mergeStyles(style['button'], showPopup ? style['red-hover'] : style['red'])}
            onClick={() => this.toggle(true)}
            onMouseEnter={this.onProblemIconHover}
          >
            <div className={style['icon-small']}>
              <ProblemIcon />
            </div>
            Будьте внимательны
          </span>
          {showPopup && this.renderPopup()}
        </OutsideClick>
      </span>
    );
  }
  private renderPopup() {
    let { url = '' } = this.props;

    if (url) {
      url = `${url}#problem`;
    }

    return (
      <span className={style['wrapper']} onMouseLeave={this.toggle(false)}>
        <Popup arrow={PopupArrow.NONE} containerStyle={style['popup']}>
          <div {...mergeStyles(style['icon'], style['red'])}>
            <ProblemIcon />
          </div>
          <strong className={style['title']}>Будьте внимательны</strong>
          <p className={style['description']}>В ЖК есть проблемные корпуса.</p>
          {url && (
            <Link
              onClick={this.onMoreButtonClick}
              href={url}
              theme="button/blueLightSolid"
              linkStyle={style['link']}
              target="_blank"
            >
              Узнать подробнее
            </Link>
          )}
        </Popup>
      </span>
    );
  }

  private toggle = (showPopup: boolean) => () => {
    this.setState({
      showPopup,
    });
  };
}
